export default __webpack_public_path__ + "locales/tr/Files.json?hash=33c44b8a7fa2f825c61cd57bd4af401e";